import React from 'react';
import { useState } from 'react';
import Popup from './popup';
import './header.css';

function Header() {
    const [isPopupOpen, setPopupOpen] = useState(false);

    const openPopup = () => {
        setPopupOpen(true);
    };
    
    const closePopup = () => {
        setPopupOpen(false);
    };

    return (
        <div>
            <header className="header">
                <h1>インターバルタイマー</h1>
                <button className="header_button header_button_help" onClick={openPopup}></button>
            </header>

            <Popup isOpen={isPopupOpen} onClose={closePopup}>
                <div className="popup_content_title">このアプリについて</div>
                <div className="popup_content_text">
                    <ul>
                        <li>二つのタイマーのカウントダウンを交互に繰り返します。</li>
                        <li>HIITなどのトレーニングや勉強、作業の時間管理にご活用ください。</li>
                        <li>時間の部分をタッチすると計測時間の変更が可能です。<br />変更した時間はブラウザに保存されます。</li>
                        <li>時間終了の3秒前にアラームが鳴ります。</li>
                    </ul>
                </div>
            </Popup>
        </div>
    );
}

export default Header;
